/**
 * vue组件错误捕获
 * slsTracker.js author gw
 * @param err
 * @param vm
 * @param info
 */
import Vue from 'vue'
Vue.config.errorHandler = (err, vm, info) => {
    if (err.isAxiosError) {
        // axios请求错误 已在request中单独处理，此处无需再次处理
        // console.log('err:', err.toString())
    } else {
        // js语法错误
        console.log(vm.$vnode.tag);
        console.log('err:', err.toString())

        if (window.location.host != 'aosmithv2.iwxapi.com') {
            return
        }

        let onerror = {
            'message': info,
            'vm': vm.$vnode.tag || '',
            'error': err.toString(),
        }
        let param = "&type=1";
        // vue需要匹配路径中的#，否则url会被截断
        param += "&url=" + encodeURIComponent(location.href)
        param += "&host=" + location.host
        let aQuery = {};
        let url = location.href
        if (url.indexOf("?") != -1) {
            let urlStr = url.split('?')[1]
            let paramsArr = urlStr.split('&')
            for (let i = 0, len = paramsArr.length; i < len; i++) {
                let arr = paramsArr[i].split('=')
                aQuery[arr[0]] = arr[1];
            }
        }
        param += "&query=" + JSON.stringify(aQuery);
        param += "&data=" + JSON.stringify(onerror);
        let errURL = "https://web-error.cn-beijing.log.aliyuncs.com/logstores/aosmith/track_ua.gif?APIVersion=0.6.0" + param;
        let logstores = new Image()
        logstores.src = errURL;
        logstores = null
    }
}